import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SelectableButton } from '../SelectableButton';

export function UnassignmentStep({ value, onChange }: { value?: boolean; onChange: (value: boolean) => void }) {
  const { t } = useTranslation('patient-transport');

  return (
    <Stack gap={4}>
      <Typography>{t('reportIncident.steps.unassignment.description')}</Typography>
      <SelectableButton isSelected={!!value} onClick={() => onChange(true)} fullWidth>
        {t('reportIncident.steps.unassignment.yes')}
      </SelectableButton>
      <SelectableButton isSelected={value === false} onClick={() => onChange(false)} fullWidth>
        {t('reportIncident.steps.unassignment.no')}
      </SelectableButton>
    </Stack>
  );
}
